import React from "react";
import { useGlobalValue } from "../utils/GlobalState";

export default function Footer() {

  const [{ service }] = useGlobalValue();

  return (
    <div>
      <br />
      <hr />
      <br />
      <div className="row justify-content-center text-center">
        <h5>{service.name} <br/>
        {service.mds_contact_address} {service.mds_contact_suburb} {service.mds_contact_postcode} {service.mds_contact_state}<br/>
        {service.mds_contact_phone} <br/>
        {service.mds_contact_email} </h5>
      </div>
    </div>
  );
}
